// Action Types
export const FETCH_LIBRARY_CARDS_REQUEST = "FETCH_LIBRARY_CARDS_REQUEST";
export const FETCH_LIBRARY_CARDS_SUCCESS = "FETCH_LIBRARY_CARDS_SUCCESS";
export const FETCH_LIBRARY_CARDS_FAILURE = "FETCH_LIBRARY_CARDS_FAILURE";

export const CREATE_LIBRARY_CARD_REQUEST = "CREATE_LIBRARY_CARD_REQUEST";
export const CREATE_LIBRARY_CARD_SUCCESS = "CREATE_LIBRARY_CARD_SUCCESS";
export const CREATE_LIBRARY_CARD_FAILURE = "CREATE_LIBRARY_CARD_FAILURE";
export const GET_LIBRARY_CARD_REQUEST = "GET_LIBRARY_CARD_REQUEST";
export const GET_LIBRARY_CARD_SUCCESS = "GET_LIBRARY_CARD_SUCCESS";
export const GET_LIBRARY_CARD_FAILURE = "GET_LIBRARY_CARD_FAILURE";

export const UPDATE_LIBRARY_CARD_REQUEST = "UPDATE_LIBRARY_CARD_REQUEST";
export const UPDATE_LIBRARY_CARD_SUCCESS = "UPDATE_LIBRARY_CARD_SUCCESS";
export const UPDATE_LIBRARY_CARD_FAILURE = "UPDATE_LIBRARY_CARD_FAILURE";

export const DELETE_LIBRARY_CARD_REQUEST = "DELETE_LIBRARY_CARD_REQUEST";
export const DELETE_LIBRARY_CARD_SUCCESS = "DELETE_LIBRARY_CARD_SUCCESS";
export const DELETE_LIBRARY_CARD_FAILURE = "DELETE_LIBRARY_CARD_FAILURE";

export const REQUEST_PRESIGNED_URL = "REQUEST_PRESIGNED_URL";
export const PRESIGNED_URL_SUCCESS = "PRESIGNED_URL_SUCCESS";
export const PRESIGNED_URL_FAILURE = "PRESIGNED_URL_FAILURE";

export const UPLOAD_FILE_REQUEST = "UPLOAD_FILE_REQUEST";
export const UPLOAD_FILE_SUCCESS = "UPLOAD_FILE_SUCCESS";
export const UPLOAD_FILE_FAILURE = "UPLOAD_FILE_FAILURE";

export const FETCH_METADATA_REQUEST = "FETCH_METADATA_REQUEST";
export const FETCH_METADATA_SUCCESS = "FETCH_METADATA_SUCCESS";
export const FETCH_METADATA_FAILURE = "FETCH_METADATA_FAILURE";

export const LIST_CARDS_REQUEST = "LIST_CARDS_REQUEST";
export const LIST_CARDS_SUCCESS = "LIST_CARDS_SUCCESS";
export const LIST_CARDS_FAILURE = "LIST_CARDS_FAILURE";

export const FETCH_CARD_DETAILS_REQUEST = "FETCH_CARD_DETAILS_REQUEST";
export const FETCH_CARD_DETAILS_SUCCESS = "FETCH_CARD_DETAILS_SUCCESS";
export const FETCH_CARD_DETAILS_FAILURE = "FETCH_CARD_DETAILS_FAILURE";

// Action Types for Tags
export const GET_LIBRARY_CARD_TAGS_REQUEST = "GET_LIBRARY_CARD_TAGS_REQUEST";
export const GET_LIBRARY_CARD_TAGS_SUCCESS = "GET_LIBRARY_CARD_TAGS_SUCCESS";
export const GET_LIBRARY_CARD_TAGS_FAILURE = "GET_LIBRARY_CARD_TAGS_FAILURE";

// Get Library Card
export const getLibraryCardRequest = (payload) => ({
  type: GET_LIBRARY_CARD_REQUEST,
  payload,
});

// Update Library Card
export const updateLibraryCardRequest = (payload) => ({
  type: UPDATE_LIBRARY_CARD_REQUEST,
  payload,
});

export const getLibraryCardIndexTags = (payload) => {
  return {
    type: GET_LIBRARY_CARD_TAGS_REQUEST,
    payload,
  };
};

// Request Presigned URL
export const requestPresignedUrl = (fileDetails) => {
  const payloadData = { type: REQUEST_PRESIGNED_URL, payload: fileDetails };
  console.log(
    `PMM - SF - libraryCardActions.js - requestPresignedUrl - payloadData is: ${JSON.stringify(
      payloadData
    )}`
  );
  return payloadData;
};

// Fetch Library Cards
export const fetchLibraryCardsRequest = (payload) => ({
  type: FETCH_LIBRARY_CARDS_REQUEST,
  payload,
});

export const fetchLibraryCardsSuccess = (cards) => ({
  type: FETCH_LIBRARY_CARDS_SUCCESS,
  payload: cards,
});

export const fetchLibraryCardsFailure = (error) => ({
  type: FETCH_LIBRARY_CARDS_FAILURE,
  payload: error,
});

// Create Library Card
export const createLibraryCardRequest = (payload) => ({
  type: CREATE_LIBRARY_CARD_REQUEST,
  payload,
});

export const createLibraryCardSuccess = (card) => ({
  type: CREATE_LIBRARY_CARD_SUCCESS,
  payload: card,
});

export const createLibraryCardFailure = (error) => ({
  type: CREATE_LIBRARY_CARD_FAILURE,
  payload: error,
});

// Update Library Card Success/Failure
export const updateLibraryCardSuccess = (card) => ({
  type: UPDATE_LIBRARY_CARD_SUCCESS,
  payload: card,
});

export const updateLibraryCardFailure = (errorMessage) => ({
  type: UPDATE_LIBRARY_CARD_FAILURE,
  payload: { error: errorMessage },
});

// Delete Library Card
export const deleteLibraryCardRequest = (cardId) => ({
  type: DELETE_LIBRARY_CARD_REQUEST,
  payload: cardId,
});

export const deleteLibraryCardSuccess = (response) => ({
  type: DELETE_LIBRARY_CARD_SUCCESS,
  payload: response,
});

export const deleteLibraryCardFailure = (error) => ({
  type: DELETE_LIBRARY_CARD_FAILURE,
  payload: error,
});

// Presigned URL Success/Failure
export const presignedUrlSuccess = (url) => ({
  type: PRESIGNED_URL_SUCCESS,
  payload: url,
});

export const presignedUrlFailure = (error) => ({
  type: PRESIGNED_URL_FAILURE,
  payload: error,
});

// Upload File
export const uploadFileRequest = (fileData) => ({
  type: UPLOAD_FILE_REQUEST,
  payload: fileData,
});

export const uploadFileSuccess = (response) => ({
  type: UPLOAD_FILE_SUCCESS,
  payload: response,
});

export const uploadFileFailure = (error) => ({
  type: UPLOAD_FILE_FAILURE,
  payload: error,
});

// Fetch Metadata
export const fetchMetadataRequest = (payload) => ({
  type: FETCH_METADATA_REQUEST,
  payload,
});

export const fetchMetadataSuccess = (metadata) => ({
  type: FETCH_METADATA_SUCCESS,
  payload: metadata,
});

export const fetchMetadataFailure = (error) => ({
  type: FETCH_METADATA_FAILURE,
  payload: error,
});

// List Library Cards
export const listCardsRequest = (payload) => ({
  type: LIST_CARDS_REQUEST,
  payload,
});

export const listCardsSuccess = (cards) => ({
  type: LIST_CARDS_SUCCESS,
  payload: cards,
});

export const listCardsFailure = (error) => ({
  type: LIST_CARDS_FAILURE,
  payload: error,
});

// Fetch Library Card Details
export const fetchCardDetailsRequest = (payload) => ({
  type: FETCH_CARD_DETAILS_REQUEST,
  payload,
});

export const fetchCardDetailsSuccess = (cardDetails) => ({
  type: FETCH_CARD_DETAILS_SUCCESS,
  payload: cardDetails,
});

export const fetchCardDetailsFailure = (error) => ({
  type: FETCH_CARD_DETAILS_FAILURE,
  payload: error,
});

// Library Card Tags
export const getLibraryCardTagsSuccess = (tags) => ({
  type: GET_LIBRARY_CARD_TAGS_SUCCESS,
  payload: tags,
});

export const getLibraryCardTagsFailure = (error) => ({
  type: GET_LIBRARY_CARD_TAGS_FAILURE,
  payload: error,
});

// List Entity Cards
export const LIST_ENTITY_CARDS_REQUEST = "LIST_ENTITY_CARDS_REQUEST";
export const LIST_ENTITY_CARDS_SUCCESS = "LIST_ENTITY_CARDS_SUCCESS";
export const LIST_ENTITY_CARDS_FAILURE = "LIST_ENTITY_CARDS_FAILURE";

export const listEntityCardsRequest = (entityType) => ({
  type: LIST_ENTITY_CARDS_REQUEST,
  payload: { entityType },
});

export const listEntityCardsSuccess = (entityType, data) => ({
  type: LIST_ENTITY_CARDS_SUCCESS,
  payload: { entityType, data },
});

export const listEntityCardsFailure = (entityType, errorMessage) => ({
  type: LIST_ENTITY_CARDS_FAILURE,
  payload: { entityType, error: errorMessage },
});
